(function () {

    const videoContainer = document.querySelector('.video-container'),
        introBannerWrap = document.querySelector('.intro-banner__wrap'),
        headerBody = document.querySelector('.header--body');

    window.addEventListener("resize", debounce(setContainerHeight));

    function init() {
        setContainerHeight();
    }

    /*
    * Returns video containter height
    */
    function getVideoContainerHeight() {
        return videoContainer.offsetHeight - headerBody.offsetHeight;
    }

    /*
    * Sets the intro banner height
    * @param height is video container height
    */
    function setIntroBannerHeight(height) {
        introBannerWrap.style.height = height + "px";
    }

    /*
    * Sets the intro container height given the offset
    * Checks to see if the video container height > intro banner height
    */
    function setContainerHeight() {
        if (videoContainer) {
            if (introBannerWrap.offsetHeight > videoContainer.offsetHeight) {
                videoContainer.style.height = introBannerWrap.offsetHeight + "px";
            }
            var videoContainerHeight = getVideoContainerHeight();
            setIntroBannerHeight(videoContainerHeight);
        }
    }

    init();
})();
